<template>
    <div class="mastercard">
        <div class="img-class">
            <img :src=img alt="Master" class="icon-size" />
        </div>
        <div class="s-content">
            <p class="master-heading-name py-2">
                {{ headcontent }}
            </p>
            <p class="content">{{ content }}</p>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
export default defineComponent({

    props: {
        // storeval: {
        //     type: Object,
        //     default: []
        // },
        headcontent: {
            type: String,
            default: ''
        },
        content: {
            type: String,
            default: ''
        },
        img: {
            type: String,
            default: ''
        },
    },
    setup() {

    }

})
</script>
